export { default } from './useId';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useId/index.js
// module id = 189
// module chunks = 22